module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-2000.324cb23f.svg";